export const saveTokenToState = (token) => {
  return {
    type: "SAVE_TOKEN",
    token,
  }
}

export function deleteErrorMessage() {
  return {
    type: "DELETE_ERROR_MESSAGE",
  }
}

export function addErrorMessage(errorMessage) {
  return {
    type: "ADD_ERROR_MESSAGE",
    errorMessage
  }
}

export function updateNewGameDetails(values) {
  return {
    type: "UPDATE_NEW_GAME_DETAILS",
    values,
  }
}

export function requestAppDetails() {
  return {
    type: "REQUEST_APP_DETAILS",
  }
}

export function receiveAppDetails(locations, products, userCountryDetected) {
  return {
    type: "RECEIVE_APP_DETAILS",
    locations,
    products,
    userCountryDetected
  }
}

export function receiveAppDetailsError(error) {
  return {
    type: "RECEIVE_APP_DETAILS_ERROR",
    error,
  }
}

export function requestUserGameDetails() {
  return {
    type: "REQUEST_USER_GAME_DETAILS",
  }
}

export function receiveUserGameDetails(details) {
  return {
    type: "RECEIVE_USER_GAME_DETAILS",
    details,
  }
}

export function receiveUserGameDetailsError(error) {
  return {
    type: "RECEIVE_USER_GAME_DETAILS_ERROR",
    error,
  }
}

export function requestTeamMembers() {
  return {
    type: "REQUEST_TEAM_MEMBERS",
  }
}

export function receiveTeamMembers(teamUuid, team) {
  return {
    type: "RECEIVE_TEAM_MEMBERS",
    teamUuid,
    team,
  }
}

export function receiveTeamMembersError(error) {
  return {
    type: "RECEIVE_TEAM_MEMBERS_ERROR",
    error,
  }
}


export function requestInviteTeamMembers(teamUuid, members) {
  return {
    type: "REQUEST_INVITE_TEAM_MEMBERS",
    teamUuid,
    members
  }
}

export function receiveInviteTeamMembers(teamUuid, team, errors) {
  return {
    type: "RECEIVE_INVITE_TEAM_MEMBERS",
    teamUuid,
    team,
    errors
  }
}

export function receiveInviteTeamMembersError(error) {
  return {
    type: "RECEIVE_INVITE_TEAM_MEMBERS_ERROR",
    error,
  }
}

export function requestDeleteTeamInvite(teamUuid, inviteUuid) {
  return {
    type: "REQUEST_DELETE_TEAM_INVITE",
    teamUuid,
    inviteUuid
  }
}

export function clearAcceptTeamInviteStatus() {
  return {
    type: "CLEAR_ACCEPT_TEAM_INVITE_STATUS"
  }
}
export function requestAcceptTeamInvite(inviteUuid) {
  return {
    type: "REQUEST_ACCEPT_TEAM_INVITE",
    inviteUuid,
  }
}

export function receiveAcceptTeamInvite(message, status, inviteUuid) {
  return {
    type: "RECEIVE_ACCEPT_TEAM_INVITE",
    message,
    status,
    inviteUuid
  }
}

export function receiveAcceptTeamInviteError(error, inviteUuid) {
  return {
    type: "RECEIVE_ACCEPT_TEAM_INVITE_ERROR",
    error,
    inviteUuid
  }
}

export function receiveUpdatedTeam(team) {
  return {
    type: "RECEIVE_UPDATED_TEAM",
    team,
  }
}


export function receiveDeleteTeamInviteError(error) {
  return {
    type: "RECEIVE_DELETE_TEAM_INVITE_ERROR",
    error,
  }
}

export function requestDeleteTeamMember(teamUuid, memberUuid) {
  return {
    type: "REQUEST_DELETE_TEAM_MEMBER",
    teamUuid,
    memberUuid
  }
}

export function receiveDeleteTeamMemberError(error) {
  return {
    type: "RECEIVE_DELETE_TEAM_MEMBER_ERROR",
    error,
  }
}

export function requestStartGame() {
  return {
    type: "REQUEST_START_GAME",
  }
}

export function receiveStartGame(gameUuid, details) {
  return {
    type: "RECEIVE_START_GAME",
    gameUuid,
    details,
  }
}

export function receiveStartGameError(error) {
  return {
    type: "RECEIVE_START_GAME_ERROR",
    error,
  }
}

export function requestUpdateGame() {
  return {
    type: "REQUEST_UPDATE_GAME",
  }
}

export function receiveUpdateGame(gameUuid, updatedGame, updatedTeam) {
  return {
    type: "RECEIVE_UPDATE_GAME",
    gameUuid,
    updatedGame,
    updatedTeam
  }
}

export function receiveUpdateGameError(error) {
  return {
    type: "RECEIVE_UPDATE_GAME_ERROR",
    error,
  }
}

export function requestLostGameDetails(gameUuid) {
  return {
    type: "REQUEST_LOST_GAME_DETAILS",
    gameUuid,
  }
}

export function clearInviteErrors(gameId) {
  return {
    type: "CLEAR_INVITE_ERRORS",
    gameId
  }
}

export function clearLostGameDetails(gameUuid) {
  return {
    type: "CLEAR_LOST_GAME_DETAILS",
    gameUuid
  }
}

export function receiveLostGameDetails(gameUuid, details) {
  return {
    type: "RECEIVE_LOST_GAME_DETAILS",
    gameUuid,
    details,
  }
}

export function receiveLostGameDetailsError(error) {
  return {
    type: "RECEIVE_LOST_GAME_DETAILS_ERROR",
    error,
  }
}

export function requestSkipAheadHelp(gameUuid) {
  return {
    type: "REQUEST_BROKEN_PHONE_HELP",
    gameUuid,
  }
}

export function clearBrokenPhoneHelp(gameUuid) {
  return {
    type: "CLEAR_BROKEN_PHONE_HELP",
    gameUuid
  }
}

export function receiveSkipAheadHelp(gameUuid, cabinetId, message, urls, verification) {
  return {
    type: "RECEIVE_BROKEN_PHONE_HELP",
    gameUuid,
    cabinetId,
    message,
    urls,
    verification
  }
}

export function receiveSkipAheadHelpError(error) {
  return {
    type: "RECEIVE_BROKEN_PHONE_HELP_ERROR",
    error,
  }
}

export const setSetupErrorText = (text) => ({
  type: "SET_SETUP_ERROR_TEXT",
  text,
})

export const clearSetupErrorText = () => ({
  type: "CLEAR_SETUP_ERROR_TEXT",
})

export const setActiveStep = (step) => ({
  type: "SET_ACTIVE_STEP",
  step,
})

export const clearActiveStep = () => ({
  type: "CLEAR_ACTIVE_STEP",
})